<template>
  <ul id="why-soda" class="cards-list">
    <h2 class="h2 cards-list__title">Why Soda Connect?</h2>

    <li
      v-for="card in cards"
      :class="['card', `card_${card.image}`]"
      :key="card.image"
    >
      <app-svg
        :icon="card.image"
        width="112"
        height="112"
        class="card__image"
      />
      <div class="card__title h3" v-html="card.title" />
      <div class="card__text text" v-html="card.text" />
    </li>
  </ul>
</template>

<script>
export default {
  setup() {
    return {
      cards: [
        {
          title: 'No speed loss',
          text: 'The app does not limit your connection speed. Performance depends only on the server.',
          image: 'speed'
        },
        {
          title: 'Easy setup',
          text: 'Minimal steps. No technical experience<br/> is required for setup.',
          image: 'settings'
        },
        {
          title: 'Dark and Light modes',
          text: 'Comfortable use<br class="no-mobile"/> at any time of day.',
          image: 'dark-mode'
        },
        {
          title: 'Stable on Apple devices',
          text: 'Works on iPhones and iPads across all supported iOS versions.',
          image: 'ios'
        },
        {
          title: 'Independent from VPN providers',
          text: 'You choose where your connection<br class="no-mobile"/> comes from',
          image: 'provider'
        }
      ]
    }
  }
}
</script>
